import { Button,Card } from "antd";
import { useState } from "react";
import { Buffer } from "buffer/";

export default function ViewerPDF (props) {
    const {FileName, FileDocument}=props
    const [numPages,setNumPages]=useState(null);
    const [pageNumber,setPageNumber]=useState(1);

    const onDocumentLoadSuccess=({numPages})=>{
        setNumPages(numPages);
        setPageNumber(1);
    }
    const changePage=(offSet)=>{
        setPageNumber(prevPageNumber=>prevPageNumber + offSet)
    }
    const changePageBack=()=>{
        changePage(-1)
    }
    const changePageNext=()=>{
        changePage(+1)
    }

    const newTabPdfViewer=(fileDocument)=>{
        const buf = Buffer.from(fileDocument);
         //Create a Blob from the PDF Stream
         const file = new Blob([buf],{ type: "application/pdf" });
         //Build a URL from the file
         const fileURL = URL.createObjectURL(file);
         //Open the URL on new Window
          const pdfWindow = window.open();
          pdfWindow.location.href = fileURL;       
    }

    return(
        <>
        <h1>Nombre del documento: {FileName}</h1>
        {/* <Card>
            <Document file={FileDocument} onLoadSuccess={onDocumentLoadSuccess} onLoadError={console.error}>
                <Page pageNumber={pageNumber} renderAnnotationLayer={false} renderTextLayer={false} ></Page>
            </Document>
        </Card>
        <p> Número de pagina {pageNumber} de {numPages}</p>
        {pageNumber > 1 && <Button onClick={changePageBack}>Anterior</Button>}
        {pageNumber < numPages && <Button onClick={changePageNext}>Siguiente</Button>} */}
        <Button onClick={()=>(newTabPdfViewer(FileDocument))}>Abrir en nueva pestaña</Button>
        </>
    )
}